<template>
  <div class="user-info-cell" :class="[`user-info-cell--${theme || 'default'}`]">
    <div class="user-info-cell-avatar">
      <img src="../../../stylesheets/images/aftersales-user.png" alt=""/>
    </div>
    <div class="user-info-cell-userinfo">
      <div class="user-info-cell-userinfo__title">{{ name }}</div>
      <div class="user-info-cell-userinfo__phone">{{ phone }}</div>
    </div>
    <div v-if="canChangeContacts" class="user-info-cell-btn " @click="$emit('callback')">变更</div>
  </div>
</template>

<script>
import authApi from '@/common/auth'

export default {
  props: {
    theme: String, // ['white', 'default']
    name: String,
    phone: String
  },
  data() {
    return {
      canChangeContacts: false
    }
  },
  async mounted() {
    const { authList } = await this.$store.state.promiseAuth
    this.canChangeContacts = authApi.haveSomeAuth([authApi.aftersales.customer_contacts_add], authList)
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;

.user-info-cell {
  width: 100%;
  padding: 30/@w2;
  position: relative;
  display: flex;
  align-items: center;

  .user-info-cell-avatar {
    width: 110/@w2;
    height: 110/@w2;
    margin-right: 20/@w2;
  }

  .user-info-cell-userinfo {
    .user-info-cell-userinfo__title {
      font-weight: bold;
      line-height: 48/@w2;
      font-size: 34/@w2;
    }

    .user-info-cell-userinfo__phone {
      font-size: 28/@w2;
      line-height: 34/@w2;
    }
  }

  .user-info-cell-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 30/@w2;
    border-radius: 24/@w2;
    border-width: 1px;
    border-style: solid;
    width: 100/@w2;
    height: 46/@w2;
    text-align: center;
    // line-height: 46/@w2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24/@w2;
    cursor: pointer;
  }

  &.user-info-cell--white {
    color: #fff;

    .user-info-cell-btn {
      color: #fff;
      border-color: #fff;
    }
  }

  &.user-info-cell--default {
    .user-info-cell-userinfo__title {
      color: #333;
    }

    .user-info-cell-userinfo__phone {
      color: #999;
    }

    .user-info-cell-btn {
      color: #3975C6;
      border-color: #3975C6;
    }
  }
}

</style>
